
/**
 * Scroll indicator scripts.
 *
 * Handles animations and changing the color of the scroll inicator.
 */

/** Dependencies -------------------------------------------- */

// External

import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin( ScrollTrigger )

// Design system

import { deriveBackgroundColorContext } from '../blocks/helpers'

/** Some helpful bois --------------------------------------- */

const inEventName = 'scrollIndicatorScrollIn'
export const inEvent = new Event( inEventName )

const outEventName = 'scrollIndicatorScrollOut'
export const outEvent = new Event( outEventName )

/** The beef ------------------------------------------------ */

/**
 * Scroll indicator mixin.
 * Provides scroll indicator functionality to single element.
 */
export let mixin = ( { node = null, config = {} } = {} ) => {

    if ( ! node ) return false

	config = Object.assign(
		{
			duration: 0.5
		},
		config
	)

    let state = {
        node,
        config,
		inner         : null,
		colorTriggers : null
    }

    let module = {

		/** Utilities -------------------------------------- */

		getCenterOffset() {
			return state.node.getBoundingClientRect().bottom - ( state.node.clientHeight / 2 )
		},

		/** Animations -------------------------------------- */

		setAnimations() {

			gsap.set( state.inner, { y: '100%' } )

			// Color-changing magic

			// Array.from( state.colorTriggers ).map(

			// 	( colorTrigger ) => {

			// 		ScrollTrigger.create(
			// 			{
			// 				trigger     : colorTrigger,
			// 				start       : () => `top ${this.getCenterOffset() + state.config.colorTriggerOffset}px`,
			// 				end         : () => `bottom ${this.getCenterOffset() + state.config.colorTriggerOffset}px`,
			// 				toggleClass : {
			// 					targets   : state.node,
			// 					className : `has-background-color-${deriveBackgroundColorContext( colorTrigger ).color}`
			// 				}
			// 			}
			// 		)
			// 	}
			// )
		},

		/** Event handlers ---------------------------------- */

		onScrollableScrolledIn() {
			gsap.to( state.inner, { y: 0, duration: state.config.duration } )
		},

        onScrollableScrolledAway() {
			gsap.to( state.inner, { y: '100%', duration: state.config.duration } )
		},
		
		/** Setup ------------------------------------------- */

		setEventBindings() {
            window.addEventListener( inEventName, this.onScrollableScrolledIn )
			window.addEventListener( outEventName, this.onScrollableScrolledAway )
		},
        
        init() {

			state.inner = node.querySelector( '[data-inner]' )

			state.colorTriggers = document.querySelectorAll( state.config.colorTriggerSelector )

			this.setEventBindings()
			this.setAnimations()
        },
    }

    return module.init()
};

/**
 * Scroll indicator module.
 * Provides an interface to apply scroll indicator functionality to all elements matching a selector.
 */
export default {

    init( { selector, config = {} }) {

        let selected = document.querySelectorAll( selector )
        if ( ! selected.length ) return

		const defaultConfig = {
			colorTriggerSelector : 'section',
			colorTriggerOffset   : 0
		}

        return Array.from( selected ).map(
			( node, index ) => mixin( { node, config: { ...defaultConfig, ...config } } )
        )
    },
};

